<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="产品类型："
            >
              <a-select
                v-model="form.productTypeId"
                placeholder="请选择产品类型"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in productTypetions"
                  :key="item.productTypeId"
                >
                  {{ item.productTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- <a-form-model-item
              label="年月:"
              prop="time"
            >
              <a-range-picker
                :value="form.time"
                :placeholder="['开始月份', '结束月份']"
                format="YYYY-MM"
                :mode="rangePickerMode"
                @panelChange="selectMonthRange"
                @change="monthChange"
              />
            </a-form-model-item> -->
          </a-form-model>
        </div>
        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @check="checkResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="rightActions"
          @export="exportCalculationCollect"
        />
      </div>
    </div>
    <div>
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      />
    </div>
  </div>
</template>

<script>
import { queryCalculationCollect, exportCalculationCollect } from '@/api/shareIncome.js'

import { queryBases, queryProductTypeBySubsidy } from '@/api/common.js'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName',
    width: '130px'
  },
  {
    title: '产品类型',
    dataIndex: 'productTypeName',
    key: 'productTypeName',
    width: '130px'
  }
]

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'check'
  }
]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]

const rightActions = [
  {
    title: '导出',
    type: 'primary',
    action: 'export',
    ghost: true,
    apis: ['@baseInfo/Export_Bases']
  }
]

export default {
  data () {
    return {
      headerActions,
      columns,
      dataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      baseOptions: [],
      productTypetions: [],
      tableActions,
      rightActions,
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      dialogTitle: null,
      form: {
        baseId: undefined,
        productTypeId: undefined
        // time: [],
        // dateStart: undefined,
        // dateEnd: undefined
      },
      rangePickerMode: ['month', 'month']
    }
  },
  created () {
    this.loading = true
    this.queryTotal()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    checkResource () {
      this.pagination.current = 1
      this.queryTotal()
    },
    queryTotal () {
      this.dataSource = []
      this.columns = [
        {
          title: '基地',
          dataIndex: 'baseName',
          key: 'baseName',
          width: '130px'
        },
        {
          title: '产品类型',
          dataIndex: 'productTypeName',
          key: 'productTypeName',
          width: '130px'
        }
      ]
      this.fetchData()
    },
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })

      let productTypetions1 = []
      let productTypetions2 = []
      await queryProductTypeBySubsidy({
        subsidyType: 3
      }).then((data) => {
        productTypetions1 = data
      })

      await queryProductTypeBySubsidy({
        subsidyType: 4
      }).then((data) => {
        productTypetions2 = data
      })

      this.productTypetions = productTypetions1.concat(productTypetions2)
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryCalculationCollect({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize - 1,
        ...this.form
      }).then((data) => {
        this.pagination.total = data.totalRecords
        this.dataSource = data.result ? data.result : []
        this.dataSourceTempt = data.result ? data.result : []
        if (this.dataSourceTempt.length > 0) {
          let len = 0
          this.dataSourceTempt.map((item, index) => {
            len = len + 1
            item.yearMonths.map((innerItem) => {
              this.$set(this.dataSource[index],
                innerItem.yearMonth,
                innerItem.amount)
            })
          })

          this.dataSource.push({ productTypeName: '合计' })
          data.amountTotals.map((item, index) => {
            this.$set(this.dataSource[len],
              item.yearMonth,
              item.amount)
          })
          data.yearMonths.map((item) => {
            this.columns.push({
              title: item,
              dataIndex: item,
              key: item,
              width: '130px',
              customRender: (text, record) => {
                if (!Number(text)) {
                  return '0.00'
                } else {
                  return text
                }
              }
            })
          })
        }
      }

      )
      this.loading = false
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.queryTotal()// 获取表格数据的接口
    },
    // selectMonthRange (value) {
    //   this.form.dateStart = value[0].format('YYYY-MM')
    //   this.form.dateEnd = value[1].format('YYYY-MM')
    //   this.form.time = [this.form.dateStart, this.form.dateEnd]
    // },
    // monthChange (value) {
    //   if (value.length === 0) {
    //     this.form.dateStart = null
    //     this.form.dateEnd = null
    //     this.form.time = value
    //   }
    // },
    async exportCalculationCollect () {
      await exportCalculationCollect({
        baseId: this.form.baseId,
        productTypeId: this.form.productTypeId
        // dateStart: this.form.dateStart,
        // dateEnd: this.form.dateEnd
      }).then((data) => {
        this.excelDown(data, '均摊计提')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

// .table {
//   width: 80%;
//   margin: 0 auto;
// }
</style>
